const VALID_TABS = ['Email', 'Performance', 'Recipients'];

const resolveRequestedTab = ({ routeState, defaultTab = 'Email' }) => {
  const requested = routeState?.prepopulatedActiveTab;
  return VALID_TABS.includes(requested) ? requested : defaultTab;
};

const resolveRecipientsTab = ({ routeState, defaultOption = 'All' }) => {
  return routeState?.reipientsTab ?? defaultOption;
};

const resolveEmailRouteState = ({ location, defaultTab = 'Email', defaultRecipientsOption = 'All' }) => {
  const routeState = location?.state ?? {};
  return {
    requestedTab: resolveRequestedTab({ routeState, defaultTab }),
    requestedRecipientsOption: resolveRecipientsTab({ routeState, defaultOption: defaultRecipientsOption }),
    autofocusFieldFromUrl: routeState?.autofocusFieldFromUrl ?? null,
    prepopulatedContacts: routeState?.prepopulatedContacts ?? null,
    cloneEmailId: routeState?.cloneEmailId ?? null,
    writingAssistantId: routeState?.writingAssistantId ?? null,
    notIncludeRecipient: !!routeState?.notIncludeRecipient,
  };
};

export { resolveEmailRouteState, resolveRequestedTab, resolveRecipientsTab, VALID_TABS };

